export function getDefaultDisplayBands(bands: string) {
  if (bands.length === 0) throw new Error("Bands can't be an empty string")

  const [hasR, hasG, hasB] = ['r', 'g', 'b'].map(band => bands.includes(band))

  if (hasR && hasG && hasB) {
    return 'rgb'
  } else if (hasR && hasG) {
    // False color
    return 'rgr'
  } else {
    // General fallback. Take first three bands (or as many as we have)
    // and fill with first band until we have three bands
    let displayBands = bands.substring(0, 3)
    while (displayBands.length < 3) {
      displayBands += bands[0]
    }

    return displayBands
  }
}
